import { useMemo } from "react"
import { useAuth } from "../contexts/AuthContext"

// Request params that point the server at the organization picked in the sidebar (superadmins only)
const useOrganizationParams = () => {
  const { selectedOrganization } = useAuth()
  const organizationId = selectedOrganization?._id

  return useMemo(() => (organizationId ? { organizationId } : {}), [organizationId])
}

export default useOrganizationParams
